<template>
  <div class="box">
    <div class="container">
      <div class="content">
        <video style="width:600px;margin-left:20px;" controls="controls" poster="https://static.daoba.com/match_world/home_v.jpg">
          <source src="https://static.daoba.com/newdaobavideo.mp4" type="video/mp4">
        </video>
        <div style="float:left;width:500px;">
            <h1>{{$t('道吧赛事平台能为组委会')}}</h1>
            <!-- <h2>{{$t('让天下没有难办的赛事')}}</h2> -->
            <div style="line-height:32px;">
              <div style="font-weight:bold;font-size: 16x;">{{$t('节省')}}{{$t('人工')}}<span class="empty" style="width:100px;"></span><b style="font-size:24px;font-weight: bold;" >50%</b></div>
              <a-progress :percent="artNum" status="active" :strokeWidth="14" :show-info="false" :stroke-color="{'10%': '#F46D6D','100%': '#F46D6D',}"/>
              <div style="font-weight:bold;font-size: 16x;">{{$t('提高')}}{{$t('的工作效率')}}<b style="font-size:24px;font-weight: bold;"><span class="empty" style="width:330px;"></span>500%</b></div>
              <a-progress :percent="effNum" status="active" :strokeWidth="14" :show-info="false" :stroke-color="{'10%': '#F46D6D','100%': '#F46D6D',}"/>
              <div style="font-weight:bold;font-size: 16x;">{{$t('规避')}}{{$t('错报漏报')}}<b style="font-size:24px;font-weight: bold;"><span class="empty" style="width:200px;"></span>100%</b></div>
              <a-progress :percent="num" status="active" :strokeWidth="14" :show-info="false" :stroke-color="{'10%': '#F46D6D','100%': '#F46D6D',}"/>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoNum',
  components: {},
  mounted () {
    let that = this
    that.timer = setInterval(function () {
      that.num++
      if (that.num > 70) {
        that.num = 70
      }

      that.artNum++
      if (that.artNum > 40) {
        that.artNum = 40
      }
      that.effNum++
      if (that.effNum > 100) {
        that.effNum = 100
        clearInterval(that.timer)
      }
    }, 20)
  },
  data () {
    return {
      num: 0,
      artNum: 0,
      effNum: 0,
      timer: null
    }
  },
  computed: {},
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.box{
  width: 100%;
  position: relative;
  top:-71px;
}
.container{
  width: 100%;
  height: 500px;
  background-image: url('../../../assets/videobg.png');
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content{
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.content /deep/.ant-progress-inner{
  background-color: transparent;
}
.empty{
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/components/VideoNum.vue